// extracted by mini-css-extract-plugin
export default {"userData":"ResendEmailDialog_userData__CPlY+"};